export default {
  app: {
    privacy: {
      policy: 'privatumo politika',
      expansive: 'Naudodamiesi Expansive, jūs sutinkate su Expansive {action}',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Sesija baigėsi',
    sessionExpiredDescription:
      'Jūsų sesija baigėsi. Prisijunkite iš naujo, kad galėtumėte toliau naudotis programa.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Pasirinkite kalbą',
      chooseLanguageDescription:
        'Pasirinkite pageidaujamą programos kalbą. Tai pakeis sąsajos ir turinio kalbą.',
    },
    userSelection: {
      cancel: 'Atšaukti',
      createNewUser: 'Jų vardas nėra sąraše',
      newUser: 'Naujas vartotojas',
      selectAnExistingUser: 'Pasirinkite esamą vartotoją',
      selectUserHint: 'Pasirinkite esamą vartotoją arba sukurkite naują, kad galėtumėte tęsti.',
      startTypingToSearch: 'Pradėkite rašyti...',
    },
    verification: {
      codeVerification: {
        continue: 'Tęsti',
        header: 'Įveskite prieigos kodą',
        invalidCode: 'Neteisingas kodas, bandykite dar kartą.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Tęsti be vietos patvirtinimo',
        enterSiteAccessCode: 'Įveskite prieigos kodą',
        locationNotEnabledOrAvailable: 'Kodėl aš tai matau?',
        notAvailable: {
          description: 'GPS vieta šiame įrenginyje nepalaikoma.',
          header: 'Vieta nepalaikoma',
        },
        notEnabled: {
          description: 'Vietos tarnybos neįjungtos arba leidimas nesuteiktas.',
          header: 'Vieta neįjungta',
        },
        notVerified: {
          description: 'GPS rodo, kad nesate objekte.',
          header: 'Vieta nepatvirtinta',
        },
        tryAgain: 'Bandyti dar kartą',
        unavailable: {
          description: 'Nepavyko patvirtinti jūsų GPS vietos.',
          header: 'Vieta nepasiekiama',
        },
        unknown: {
          description: 'Nepavyko nustatyti jūsų vietos.',
          header: 'Vieta nežinoma',
        },
        verified: {
          description: 'GPS rodo, kad esate objekte.',
          header: 'Vieta patvirtinta',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Nerasta turtų',
        emptyDescription: 'Šiam darbo užsakymui nepriskirta jokių turtų.',
        warrantyParts: 'Dalių garantija baigiasi',
        serialNumber: 'Serijos numeris',
        none: '<nėra>',
      },
      updates: {
        emptyTitle: 'Nerasta atnaujinimų',
        emptyDescription: 'Šiam darbo užsakymui nėra jokių atnaujinimų.',
        unknownUser: 'Nežinomas vartotojas',
        none: 'Nėra',
        addComment: {
          buttonLabel: 'Pridėti komentarą',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Pavojai',
          no: 'Ne',
          yes: 'Taip',
        },
      },
    },
    attachmentsList: {
      attachments: 'Priedai',
      documents: 'Dokumentai',
      siteDocuments: 'Objekto dokumentai',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Pavojai',
        induction: 'Įvadinė instrukcija',
        safeToProceed: 'Saugus tęsti',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Terminas',
        activeSessions: 'Aktyvios sesijos',
        activeSessionsDescription:
          'Jūs jau esate prisijungę prie šių darbo užsakymų. Prieš prisijungdami prie naujo darbo užsakymo, turite atsijungti nuo šių darbo užsakymų.',
        resumeSession: 'Tęsti',
        startTime: 'Pradėta',
        unexpectedErrorTitle: 'Nenumatyta klaida',
        unexpectedErrorMessage:
          'Įvyko nenumatyta klaida kuriant jūsų sesijas. Prašome bandyti vėl vėliau.',
        engineerNotFound: 'Inžinierius nerastas',
        engineerNotFoundDescription:
          'Inžinierius, kurį bandote prisijungti, nerastas sistemoje. Prašome susisiekti su administratoriumi.',
      },
      verification: {
        code: {
          description:
            'Norėdami prisijungti, gauti 4 skaitmenų kodą iš objekto vadovo arba paskirto kontakto.',
        },
        geo: {
          continue: 'Tęsti',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Norint užbaigti apsilankymą, kreipkitės į objekto vadovą arba paskirtą kontaktą dėl prieigos kodo.',
            checkOut: 'Atsijungti',
            completeBeforeLeaving: 'Prašome užpildyti šią formą prieš išeinant.',
            continue: 'Tęsti',
            noResolutionSelected: 'Prašome pasirinkti sprendimą prieš tęsiant.',
            quoteRequired: {
              hint: 'Vizitas baigtas, pasiūlymas sekd.',
              label: 'Reikalingas pasiūlymas',
            },
            returnVisitRequired: {
              hint: 'Mes vėl sugrįšime užbaigti',
              label: 'Reikalingas pakartotinis vizitas',
            },
            serviceCompleted: {
              hint: 'Daugiau veiksmų nereikia',
              label: 'Paslauga baigta',
            },
            uploadCheckout: 'Įkelti failą, nuotrauką ar vaizdo įrašą',
            visitNotes: 'Vizito pastabos',
            workOrderResolution: 'Darbo užsakymo sprendimas',
            enterNotes: 'Įveskite bet kokias pastabas čia...',
            errors: {
              timedOut: 'Laikas baigėsi, viršyta 30 sekundžių. Bandykite dar kartą.',
              closingSession: 'Klaida uždarant sesiją',
            },
          },
          success: {
            description:
              'Ačiū, kad apsilankėte {site}. | {site} vis dar turi 1 atvirą darbo užsakymą. | {site} vis dar turi {count} atvirų darbo užsakymų.',
            endVisit: 'Užbaigti vizitą',
            header: 'Sėkmingai atsijungėte',
            viewWorkOrders: 'Prisijunkite prie kito darbo užsakymo',
          },
          verification: {
            code: {
              description:
                'Norėdami atsijungti, gauti 4 skaitmenų kodą iš objekto vadovo arba paskirto kontakto.',
              continue: 'Tęsti',
            },
            geo: {
              checkOut: 'Atsijungti',
              continue: 'Tęsti',
            },
          },
        },
        detail: {
          assets: 'Turtas',
          call: 'Skambinti',
          checkOut: 'Atsijungti',
          closed: 'Uždaryta',
          details: 'Išsami informacija',
          dueBy: 'Terminas',
          manageEngineers: 'Tvarkyti inžinierius',
          notAvailable: 'Nėra prieinama',
          pointOfContact: 'Kontaktinis asmuo',
          siteAccessTimes: 'Objekto prieigos laikai',
          siteAccessInstructions: 'Prieigos instrukcijos',
          siteAddress: 'Objekto adresas',
          siteNotes: 'Objekto pastabos',
          siteTelephone: 'Objekto telefonas',
          siteLocation: 'Objekto vieta',
          updates: 'Atnaujinimai',
          more: 'Daugiau',
          mismatchErrorTitle: 'Darbo užsakymo klaida',
          mismatchErrorMessage:
            'Darbo užsakymas, prie kurio bandote prisijungti, nesutampa su tuo, prie kurio šiuo metu esate prisijungę. Prašome patikrinti savo darbo užsakymą ir bandyti dar kartą.',
          siteDocuments: 'Objekto dokumentai',
          validFrom: 'Galioja nuo',
          validUntil: 'Galioja iki',
          documentName: 'Dokumento pavadinimas',
          documentType: 'Dokumento tipas',
          attachments: 'Darbo užsakymo failai',
          download: 'Atsisiųsti',
          workDetails: 'Darbo detalės',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Pridėti pagalbinį inžinierių',
            assistantEngineers: 'Pagalbiniai inžinieriai',
            description:
              'Dėl saugumo priežasčių, prašome nurodyti kiekvieno objekto inžinieriaus vardus.',
            editMainEngineer: 'Redaguoti pagrindinį inžinierių',
            errors: {
              creatingEngineer: 'Klaida kuriant inžinierių',
              creatingSession: 'Klaida kuriant sesiją',
            },
            header: 'Inžinieriai objekte',
            mainEngineer: 'Pagrindinis inžinierius',
            newAssistantEngineer: 'Įveskite visą jų vardą',
            next: 'Kitas',
            removeEngineer: 'Pašalinti inžinierių',
            selectExistingAssistantEngineer: 'Pradėkite rašyti jų vardą',
          },
          index: {
            description:
              'Dėl saugumo priežasčių, prašome nurodyti kiekvieno objekto inžinieriaus vardus.',
            errorCreatingEngineer: 'Klaida kuriant inžinierių, prašome bandyti dar kartą.',
            header: 'Inžinieriai objekte',
            hintMainEngineer: 'Įveskite pagrindinio inžinieriaus visą vardą',
            newMainEngineer: 'Naujas pagrindinis inžinierius',
            next: 'Kitas',
            selectExistingMainEngineer: 'Pasirinkite esamą pagrindinį inžinierių',
            yes: 'Taip',
            no: 'Ne',
            mainEngineerLabel: 'Ar jūs pagrindinis inžinierius?',
          },
        },
        index: {
          callUsOn: 'Skambinkite mums numeriu {phoneNumber}',
          description: 'Negalite rasti to, ko ieškote?',
          dueBy: 'Terminas',
          header: 'Pasirinkite darbo užsakymą',
          notAvailable: 'Nėra prieinama',
          searchWorkOrders: 'Ieškoti darbo užsakymų...',
        },
        manageEngineers: {
          manageEngineers: 'Tvarkyti inžinierius',
          notWorking: 'Neaktyvūs darbuotojai',
          pause: 'Pauzė',
          resume: 'Tęsti',
          workingNow: 'Aktyvūs darbuotojai',
          startTime: 'Pradžios laikas',
          endTime: 'Pabaigos laikas',
          duration: 'Trukmė',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Atsiliepimai',
            feedbackDescription:
              'Prašome pateikti atsiliepimus apie darbo užsakymą, kad padėtumėte mums tobulinti mūsų paslaugas.',
            feedbackLabel: 'Atsiliepimai',
            filesLabel: 'Priedai',
            submissionLabel: 'Pateikti atsiliepimus',
          },
          hazards: {
            back: 'Grįžti',
            hazards: 'Pavojai',
            next: 'Kitas',
            no: 'Ne',
            noTasksForHazard: 'Šiam pavojui nėra užduočių.',
            yes: 'Taip',
          },
          induction: {
            continue: 'Tęsti',
            induction: 'Įvadinė instrukcija',
          },
          index: {
            checkIn: 'Prisijungti',
            description: 'Prašome užpildyti šią rizikos vertinimo formą pasirinktam darbui.',
            fail: 'Nepavyko apdoroti pradžios darbo užsakymo patikrinimų.',
            haltMessage:
              'Nustatyti potencialūs pavojai. Prašome sustabdyti darbus, peržiūrėti saugos gaires ir susisiekti su savo priežiūros specialistu dėl tolesnių nurodymų.',
            header: 'Pradžios darbo patikrinimai',
            endVisit: 'Užbaigti vizitą',
            leaveFeedback: 'Palikti atsiliepimus',
          },
          safeToProceed: {
            continue: 'Tęsti',
            safeToProceed: 'Saugus tęsti',
          },
        },
      },
    },
    index: {
      title: 'Sveiki atvykę',
      description: 'Nuskanuokite QR kodą savo vietoje, kad pradėtumėte.',
    },
    login: {
      errorTitle: 'Nenumatyta klaida',
      errorMessage: 'Įvyko nenumatyta klaida. Prašome bandyti dar kartą nuskanuoti QR kodą.',
    },
    unauthenticated: {
      welcome: {
        title: 'Sveiki atvykę į {site}',
        description:
          'Prieš rodant bet kokius darbo užsakymus, reikia patvirtinti jūsų duomenis. Paspauskite žemiau esantį mygtuką, kad tęstumėte.',
        next: 'Tęsti',
      },
      index: {
        errorTitle: 'Nenumatyta klaida',
        errorMessage: 'Įvyko nenumatyta klaida. Prašome bandyti dar kartą nuskanuoti QR kodą.',
      },
      contractor: {
        title: 'Kamdėl dirbate?',
        contractor: 'Sutartininkas',
        contractorLabel: 'Pradėkite rašyti savo įmonės pavadinimą',
        contractorHint: 'Turite įvesti 3 simbolius ar daugiau, kad pamatytumėte rezultatus',
        defaultSelectPlaceholder: '--Prašome pasirinkti--',
        next: 'Kitas',
      },
      user: {
        title: 'Kas jūs esate?',
        cancel: 'Atšaukti',
        createNewUserLabel: 'Mano vardo nėra sąraše',
        existingUserLabel: 'Pradėkite rašyti savo vardą',
        existingUserHint: 'Turite įvesti 3 simbolius ar daugiau, kad pamatytumėte rezultatus',
        newUserLabel: 'Įveskite savo visą vardą',
        next: 'Kitas',
        user: 'Vartotojas',
      },
      verification: {
        methods: {
          add: {
            add: 'Pridėti patvirtinimo metodą',
            defaultSelectPlaceholder: '--Prašome pasirinkti--',
            emailLabel: 'El. paštas',
            existingMethodWarning:
              'Jūs jau turite laukiančią šio patvirtinimo metodo užklausą, kuri laukia administratoriaus patvirtinimo. Naujo pridėjimas ją perrašys.',
            method: 'Metodas',
            methodLabel: 'Metodas',
            mobileCountryHint: 'Prašome pasirinkti savo šalies kodą',
            mobileCountryLabel: 'Mobiliojo telefono šalies kodas',
            mobileHint: 'Prašome įvesti savo mobiliojo telefono numerį',
            mobileLabel: 'Mobilusis',
            title: 'Pridėti patvirtinimo metodą',
          },
          confirm: {
            confirm: 'Patvirtinti',
            description: 'Prašome patvirtinti savo patvirtinimo metodą, kad tęstumėte.',
            label: 'Įveskite savo kodą',
            resend: 'Persiųsti',
            resendPrompt: 'Nepavyko gauti kodo?',
            title: 'Patvirtinti patvirtinimo metodą',
          },
          confirmed: {
            description:
              'Būsite informuotas, kai šis patvirtinimo metodas bus patvirtintas jūsų administratoriaus, ir tada galėsite pradėti jį naudoti savo tapatybei patvirtinti.',
            forceApproval: 'Kol jis bus patvirtintas, negalėsite prieiti prie darbo užsakymų.',
            nonForceApproval:
              'Tuo tarpu galite toliau prieiti prie darbo užsakymų su sumažinta prieiga.',
            nonForceApprovalButtonLabel: 'Tęsti su sumažinta prieiga',
            title: 'Laukiama patvirtinimo',
          },
          addNew: 'Pridėti naują patvirtinimo metodą',
          description:
            'Turime patvirtinti jūsų tapatybę, kad galėtume suteikti jums pilną prieigą prie darbo užsakymo.',
          email: 'El. paštas',
          hint: 'Mes atsiųsime nuorodą į jūsų pasirinkto patvirtinimo metodo, kuri suteiks jums pilną prieigą prie darbo užsakymo. Jei reikia pakeisti kokius nors esamus patvirtinimo metodus, prašome susisiekti su savo administratoriumi.',
          label: 'Pasirinkite patvirtinimo metodą',
          next: 'Kitas',
          pendingHint: 'Laukiama administratoriaus patvirtinimo',
          sms: 'SMS',
          title: 'Patvirtinimas',
        },
        optional: {
          hint: 'Jūsų vartotojo duomenų patvirtinimas suteiks jums pilną prieigą prie darbo užsakymo',
          label: 'Ar norite patvirtinti savo vartotojo duomenis?',
          next: 'Kitas',
          no: 'Ne',
          noHint:
            'Aš nenoriu patvirtinti savo vartotojo duomenų ir tęsti su sumažinta prieiga prie darbo užsakymo',
          title: 'Patvirtinimas',
          yes: 'Taip',
          yesHint:
            'Aš noriu patvirtinti savo vartotojo duomenis ir gauti pilną prieigą prie darbo užsakymo',
        },
        sent: {
          description:
            'Prisijungimo nuoroda buvo išsiųsta į {identifier}. Prašome paspausti nuorodą, kad baigtumėte prisijungimą.',
          title: 'Išsiųsta prisijungimo nuoroda',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Vakar',
      today: 'Šiandien',
      days: {
        monday: 'Pirmadienis',
        tuesday: 'Antradienis',
        wednesday: 'Trečiadienis',
        thursday: 'Ketvirtadienis',
        friday: 'Penktadienis',
        saturday: 'Šeštadienis',
        sunday: 'Sekmadienis',
      },
      months: {
        january: 'Sausis',
        february: 'Vasaris',
        march: 'Kovas',
        april: 'Balandis',
        may: 'Gegužė',
        june: 'Birželis',
        july: 'Liepa',
        august: 'Rugpjūtis',
        september: 'Rugsėjis',
        october: 'Spalis',
        november: 'Lapkritis',
        december: 'Gruodis',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Kažkas nepavyko',
      message: 'Prašome bandyti dar kartą nuskanuoti QR kodą.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Nežinomas vartotojas',
      },
      none: 'Nėra',
      types: {
        stateTransition: 'Statuso pakeitimas',
        contractorAssigned: 'Sutartininkas priskirtas',
        engineerAssigned: 'Inžinierius priskirtas',
        serviceAssigned: 'Paslauga priskirta',
        priorityChanged: 'Prioritetas pakeistas',
        actionableDateChanged: 'Veiksminga data pakeista',
        dueDateChanged: 'Termino data pakeista',
        etaDateChanged: 'Numatomo atvykimo laiko data pakeista',
        spendLimitApproved: 'Išlaidų limito patvirtinimas',
        spendLimitCancelled: 'Išlaidų limito prašymo atšaukimas',
        spendLimitRejected: 'Išlaidų limito atmetimas',
        spendLimitRequested: 'Prašymas dėl išlaidų limito',
        jobSheetUploaded: 'Darbo lapas įkeltas',
        slaAlertSent: 'Laiko reikalavimų pažeidimo įspėjimas',
        issuedWorkPermit: 'Darbo leidimas išduotas',
        requestForServiceSent: 'Prašymas dėl paslaugos išsiųstas',
        comment: 'Komentaras pridėtas',
        unknown: 'Nežinomas įvykis',
      },
      labels: {
        actionableDate: 'Veiksminga data',
        comment: 'Komentaras',
        file: 'Failas',
        contractor: 'Sutartininkas',
        dueDate: 'Termino data',
        etaDate: 'Numatomas atvykimo laikas',
        engineer: 'Inžinierius',
        priority: 'Prioritetas',
        requestForService: 'Prašymas dėl paslaugos',
        service: 'Paslauga',
        spendLimit: 'Išlaidų limitas',
        status: 'Statusas',
        workPermit: 'Darbo leidimas',
      },
    },
  },
}
